import React, {Component} from 'react'
import {GoogleLogin, GoogleLogout} from 'react-google-login'
import Axios from 'axios'
import { FaQuestionCircle } from "react-icons/fa"
import Modal from 'react-responsive-modal'
import imgError from '../../media/error.gif'
import axios from 'axios'
const linkGoogle = "https://docs.google.com/presentation/d/e/2PACX-1vQxVgy0ILooBay5JyVkDEaGmKWNuThAsEPjsvTrBebpvDIeb5WFgduSTem3FwnN-CyR_IYL0Dp4JBJa/pub?start=false&loop=false&delayms=60000&slide=id.p2"
const CLIENTID = process.env.REACT_APP_GOOGLE_CLIENT_ID

class Login extends Component {
    constructor (){
        super()
        this.state = {
            btnTextLogout: `Cerrar Sesión`,
            btnLogout: "hidden",
            btnLogin: "show",
            user:{
                email: "",
                name: ""
            },
            open: false,
            isAuthenticated: false
        }
    }

    componentDidMount(){
        if(localStorage.getItem("token"))
        this.setState({isAuthenticated: true, btnTextLogout:`Cerrar sesión ${localStorage.getItem("name")}`,
                user: {name: localStorage.getItem("name"), email: localStorage.getItem("email")}, 
                btnLogin: "hidden", btnLogout: "show"})
    }

    onFailure = (error) => {
        console.error(error)
    }

    responseGoogle = (response) => {
        if(!this.state.isAuthenticated){
            let user = {
                name: response.profileObj.name, 
                email: response.profileObj.email
            }
            console.log(this.state.isAuthenticated)
            Axios.post('/api/login', user).then((res) => {
                this.setState({isAuthenticated: true, user:res.data.name, token:res.data.token})
                localStorage.setItem('token', res.data.token);
                localStorage.setItem('name', res.data.name);
                localStorage.setItem('email', res.data.email);
                localStorage.setItem('permission', res.data.permission);
                this.setState({btnTextLogout:`Cerrar sesión ${res.data.name}`,
                    user: {name: res.data.name, email: res.data.email}, 
                    btnLogin: "hidden", btnLogout: "show"})
                window.location.reload()
            }).catch(err => {
                console.log(err)
                localStorage.clear()
                this.setState({open: true})
                document.getElementById('modalText').innerHTML = 'Por el momento no podemos atender tu solicitud por favor intentalo mas tarde'
            })
        }
    }

    reload = () => {
        window.location.reload()
    }

    logout = (response) => {
        console.log(response)
        localStorage.clear()
        window.location.reload()
    }

    render(){
        return(
            <div className="d-flex flex-row-reverse">
                <div className={this.state.btnLogin}>
                    <GoogleLogin
                        disabled={false}
                        clientId={CLIENTID}
                        buttonText="Iniciar Sesión"
                        onSuccess={this.responseGoogle}
                        onFailure={this.onFailure}
                        cookiePolicy={'single_host_origin'}
                        isSignedIn={true}
                    />
                </div>
                <div className={this.state.btnLogout}>
                    <GoogleLogout
                        clientId={CLIENTID}
                        buttonText={this.state.btnTextLogout}
                        onLogoutSuccess={this.logout}
                    />
                    <a href={linkGoogle} target="_blank"><FaQuestionCircle size={26} className="questionMark"/></a>
                </div>
                <Modal open={this.state.open} showCloseIcon={false} closeOnEsc={false} closeOnOverlayClick={false} center>
                    <h2 id="modalTittle" className="modalTittle">Error</h2>
                    <div id="modalContent">
                        <img src={imgError} className="modalImg" alt="error"></img>
                        <br></br>
                        <button onClick={this.reload} className="btn btn-success modalBtnUnique">Aceptar</button>
                        <p className="modalText" id="modalText">Por favor ingresa con tu cuenta marhnos</p>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default Login


// WEBPACK FOOTER //
// ./src/components/Login/Login.js